import { tailwind } from "@theme-ui/presets"

const theme = {
    ...tailwind,
    initialColorMode: 'light',
    useCustomProperties: true,
    colors: {
        ...tailwind.colors,
        text: 'gray.2',
        background: 'purple.2',
        primary: '#07c',
        modes: {
            dark: {
                text: '#eee',
                background: '#000',
            },
            light: {
                text: '#3e3e3e',
                background: '#fff',
            }
        }
    },
    layout: {
        header: {
            color: 'gray.8',
            backgroundColor: 'gray.3',
        },
        footer: {
            color: 'gray.5',
            backgroundColor: 'gray.9',
            textAlign: 'center'
        },
    },
    buttons: {
        ...tailwind.buttons,
        transparent: {
            color: `inherit`,
            bg: `transparent`,
            transition: `all 0.3s ease-in-out`,
            border: `none`,
            "&:hover, &:focus": {
                color: `primary`,
                outline: `none`,
                boxShadow: `0 0 0 2px`,
                cursor: `pointer`,
            },
        },
    },
}

export default theme